import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import Select from "react-select";

const AddProjectUser = ({ Users, Roles, handleAdd }) => {
  const [open, setOpen] = React.useState(false);
  const [user, setUser] = React.useState(0);
  const [role_list, setRoleList] = React.useState([]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setUser(0);
    setRoleList([]);
    setOpen(false);
  };

  const handleCreate = () => {
    if (user !== 0 && role_list.length > 0) {
      setOpen(false);
      handleAdd(user, role_list);
      window.location.reload()
    } else {
      toaster('error', 'Please select both user and role');
    }
  };

  const handleChange = ({ target }) => {
    if (target.name === "user") {
      setUser(target.value);
    }
  };

  const changeRoleValue = (roleValue) => {
    setRoleList(roleValue === null ? [] : roleValue)
  }

  return (
    <React.Fragment>
      <div className="float-right">
        <button
          className="btn btn-outline-blue rounded-0"
          onClick={handleClickOpen}
        >
          + New User
        </button>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Add Project User</DialogTitle>
        <DialogContent>
          <div className="form-group">
            <label htmlFor="newUser" className="small">
              User
            </label>
            <select
              name="user"
              id="newUser"
              className="form-control"
              onChange={handleChange}
              value={user}
            >
              <option key="-1">- Select -</option>
              {Users.map((user) => (
                <option value={user.User_ID} key={"userOpt" + user.User_ID}>
                  {user.Name + "(" + user.Username + ")"}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="newUserRole" className="small">
              Role
            </label>
            <Select
              isMulti
              isDisabled={false}
              options={Roles}
              name='role'
              onChange={changeRoleValue}
              placeholder='Select Roles...'
              value={role_list}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleCreate} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer/>
    </React.Fragment>
  );
};

export default AddProjectUser;
